import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-11ce6247")

_pushScopeId("data-v-11ce6247")
const _hoisted_1 = { class: "loading" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "loading__text" }, "Loading", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "loading__animation" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
})